import { uploadTOS3BucketUrl } from "../../services/QualificationService";
export const handleUploadToS3BucketUrl = async (files, fileListData, onProgress) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    if (Array.isArray(fileListData) && fileListData.length > 0) {
      const uploadPromises = fileListData.map((fileData, i) => {
        const uploadURL = uploadURLList[i]?.uploadURL;
        const fileKey = uploadURLList[i]?.fileKey;
        const file = fileData.file ;

        if (!file || !uploadURL) return Promise.resolve(null);

        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', uploadURL, true);
          xhr.setRequestHeader('Content-Type', file.type);
          
          xhr.upload.onprogress = (progressEvent) => {
            if (onProgress && progressEvent.lengthComputable) {
              onProgress(progressEvent, i);
            }
          };
          
          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve({
                path: fileKey,
                size: file.size,
              });
            } else {
              reject(new Error(`Upload failed for ${file.name} with status ${xhr.status}`));
            }
          };
          
          xhr.onerror = () => {
            reject(new Error(`Network error during upload for ${file.name}`));
          };
          
          xhr.send(file);
        });
      });

      const results = await Promise.all(uploadPromises);
      // filter out nulls (in case of skipped files)
      return results.filter(Boolean);
    } else {
      // Single file fallback
      const uploadURL = uploadURLList[0]?.uploadURL;
      const fileKey = uploadURLList[0]?.fileKey;

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadURL, true);
        xhr.setRequestHeader('Content-Type', fileListData?.type);
        
        xhr.upload.onprogress = (progressEvent) => {
          if (onProgress && progressEvent.lengthComputable) {
            onProgress(progressEvent, 0);
          }
        };
        
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve([{
              path: fileKey,
              size: fileListData?.size,
            }]);
          } else {
            reject(new Error(`S3 upload failed with status: ${xhr.status}`));
          }
        };
        
        xhr.onerror = () => {
          reject(new Error(`Network error during S3 upload`));
        };
        
        xhr.send(fileListData);
      });
    }

  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};


export const handleUploadToS3BucketUrl2 = async (files, fileListData, onProgress) => {
  if (!files || files.length === 0) return;

  try {
    const formData = new FormData();
    formData.append("uploadFiles", JSON.stringify(files));

    const response = await uploadTOS3BucketUrl(formData);
    const uploadURLList = response.data?.data || [];

    if (!uploadURLList.length || uploadURLList.length !== files.length) {
      throw new Error("Mismatch in number of files and upload URLs");
    }

    const uploadPromises = fileListData.map((fileData, i) => {
      const uploadURL = uploadURLList[i]?.uploadURL;
      const fileKey = uploadURLList[i]?.fileKey;
      const file = fileData.file;
      const customId = fileData?.meta?.customId;

      if (!file || !uploadURL || !customId) {
        console.warn(`Skipping upload for file at index ${i}: Missing file, URL, or customId`);
        return Promise.resolve(null);
      }

      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadURL, true);
        xhr.setRequestHeader('Content-Type', file.type);
        
        xhr.upload.onprogress = (progressEvent) => {
          if (onProgress && progressEvent.lengthComputable) {
            const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(customId, percent); 
          }
        };
        
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve({
              path: fileKey,
              size: file.size,
              customId,
            });
          } else {
            console.error(`Upload failed for ${file.name} with status ${xhr.status}`);
            resolve(null);
          }
        };
        
        xhr.onerror = () => {
          console.error(`Network error during upload for ${file.name}`);
          resolve(null);
        };
        
        xhr.send(file);
      });
    });

    const results = await Promise.all(uploadPromises);
    return results.filter(Boolean);
  } catch (error) {
    console.error("Error in file upload:", error);
    throw error;
  }
};
